export default __webpack_public_path__ + "static/media/complete_card.c7504e60.jpeg";